import React, { useState, useEffect } from 'react';
import MasterLayout from '../masterLayout/MasterLayout';
import PurchaseOrderLayer from '../components/PurchaseOrderLayer';
import { Icon } from '@iconify/react';
import { useLocation } from 'react-router-dom';

const PurchaseOrderPage = () => {
  const [viewMode, setViewMode] = useState('panel');
  const location = useLocation();
  const params = new URLSearchParams(location.search);
  const purchaseOrderNumber = params.get('purchaseordernumber') || '';

  useEffect(() => {
    if (purchaseOrderNumber) {
      setViewMode('panel');
    }
  }, [purchaseOrderNumber]);

  const headerActions = (
    <div className="btn-group" role="group">
      <button
        type="button"
        className={`btn btn-sm ${viewMode === 'table' ? 'bg-white text-muted border-light' : 'btn-light-100 text-muted'}`}
        onClick={() => setViewMode('table')}
      >
        <Icon icon="ic:baseline-table-view" className="icon text-xl line-height-1" /> Table
      </button>
      <button
        type="button"
        className={`btn btn-sm ${viewMode === 'panel' ? 'bg-white-300 text-muted border-light' : 'btn-light-100 text-muted'}`}
        onClick={() => setViewMode('panel')}
      >
        <Icon icon="ic:baseline-view-sidebar" className="icon text-xl line-height-1" /> Panel
      </button>
    </div>
  );

  return (
    <MasterLayout pageTitle="Purchase Orders" headerActions={headerActions}>
      <PurchaseOrderLayer
        viewMode={viewMode}
        initialPurchaseOrderNumber={purchaseOrderNumber}
      />
    </MasterLayout>
  );
};

export default PurchaseOrderPage;
